import { render, staticRenderFns } from "./EventsView.vue?vue&type=template&id=73b6901b"
import script from "./EventsView.vue?vue&type=script&lang=js"
export * from "./EventsView.vue?vue&type=script&lang=js"
import style0 from "./EventsView.vue?vue&type=style&index=0&id=73b6901b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports